import { render, staticRenderFns } from "./UploadLogosModal.vue?vue&type=template&id=47e1b3f8&scoped=true&"
import script from "./UploadLogosModal.vue?vue&type=script&lang=js&"
export * from "./UploadLogosModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadLogosModal.vue?vue&type=style&index=0&id=47e1b3f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1b3f8",
  null
  
)

export default component.exports